import React, { useState } from "react";
import { Image, XStack, YStack, Select } from "tamagui";
import { Check, ChevronDown } from "@tamagui/lucide-icons-2";
import { XPPlatform } from "../../../UtilComponents/XPPlatform.mjs";
import "./index.css";
import { getImageColorStyle } from "@my/util";
import { jsx, jsxs } from "react/jsx-runtime";
const DEFAULT_ICON_SIZE = 16;
const DEFAULT_ICON_COLOR = "#959595";
const DropDownPickerView = props => {
  const {
    ViewStyle,
    DropDownStyle,
    ContainerStyles,
    DropDownContainerStyle,
    DropDowntextStyle,
    value,
    setValue,
    items,
    iconSize = DEFAULT_ICON_SIZE,
    iconColor = DEFAULT_ICON_COLOR,
    labelStyle,
    placeholder,
    InputIcon,
    tintColor,
    TriggerStyle,
    inputWidth = "100%",
    inputHeight = 44,
    bottomBorderColor = "rgb(224, 225, 230)",
    className = "",
    native
  } = props;
  const [open, setOpen] = useState(false);
  const extraSelectProps = {
    //style: { flexGrow: 1 }
  };
  if (native) {
    extraSelectProps["native"] = true;
    Object.assign(extraSelectProps, TriggerStyle || {});
    if (!extraSelectProps["style"]) {
      extraSelectProps["style"] = {};
    }
    Object.assign(extraSelectProps["style"], {
      textWrap: "nowrap"
    });
  }
  const defaultStyles = {
    view: {
      width: "100%",
      alignItems: "center",
      zIndex: XPPlatform.OS === "web" ? void 0 : open ? 10 : -2,
      backgroundColor: "#fff",
      height: 45,
      borderRadius: 4,
      borderColor: "#E9ECEF",
      borderWidth: 2,
      paddingLeft: 15
    },
    dropDown: {
      borderWidth: 0,
      backgroundColor: "transparent",
      width: "100%",
      zIndex: -100
    },
    container: {
      width: "95%",
      height: 45
    },
    text: {
      color: "#959595",
      fontSize: 14
    },
    dropDownContainer: {
      borderWidth: 1,
      maxHeight: 120,
      borderRadius: 4,
      backgroundColor: "#fff",
      zIndex: 1e5,
      borderColor: "#E9ECEF"
    },
    placeholder: {
      paddingHorizontal: 5,
      paddingVertical: 5,
      overflow: "hidden"
      // `hidden` is valid here for TextStyle
    },
    label: {
      paddingHorizontal: 5,
      paddingVertical: 5,
      overflow: "hidden"
      // `hidden` is valid here for TextStyle
    }
  };
  const viewStyle = [defaultStyles.view, ViewStyle];
  return /* @__PURE__ */jsx(XStack, {
    alignItems: "center",
    width: inputWidth,
    height: inputHeight,
    justifyContent: "space-between",
    paddingVertical: 10,
    className: "DropDownPickerView " + (className ? className : ""),
    ...(ContainerStyles?.[0] ? ContainerStyles[0] : {}),
    children: /* @__PURE__ */jsxs(XStack, {
      style: {
        alignItems: "center",
        /* justifyContent: 'center', */
        width: "100%",
        ...(ContainerStyles?.[1] ? ContainerStyles[1] : {})
      },
      children: [InputIcon ? /* @__PURE__ */jsx(YStack, {
        height: "100%",
        justifyContent: "center",
        marginRight: 10,
        children: /* @__PURE__ */jsx(Image, {
          src: InputIcon,
          style: {
            width: 15,
            ...getImageColorStyle(tintColor)
          },
          resizeMode: "contain",
          tintColor
        })
      }) : null, /* @__PURE__ */jsx(XStack, {
        style: {
          flexGrow: 1,
          overflow: "hidden",
          borderRadius: 9,
          border: "0px solid " + bottomBorderColor,
          ...(ContainerStyles?.[2] ? ContainerStyles[2] : {})
        },
        children: /* @__PURE__ */jsxs(Select, {
          value,
          onValueChange: setValue,
          disablePreventBodyScroll: true,
          ...extraSelectProps,
          children: [/* @__PURE__ */jsx(Select.Trigger, {
            iconAfter: ChevronDown,
            ...(TriggerStyle || {}),
            children: /* @__PURE__ */jsx(Select.Value, {
              placeholder: props.placeholder
            })
          }), /* @__PURE__ */jsxs(Select.Content, {
            children: [/* @__PURE__ */jsx(Select.ScrollUpButton, {}), /* @__PURE__ */jsx(Select.Viewport, {
              children: /* @__PURE__ */jsxs(Select.Group, {
                children: [/* @__PURE__ */jsx(Select.Label, {}), React.useMemo(() => items.map((item, i) => {
                  return /* @__PURE__ */jsxs(Select.Item, {
                    index: i,
                    value: item.value,
                    children: [/* @__PURE__ */jsx(Select.ItemText, {
                      children: item.label
                    }), /* @__PURE__ */jsx(Select.ItemIndicator, {
                      marginLeft: "auto",
                      children: /* @__PURE__ */jsx(Check, {
                        size: 16
                      })
                    })]
                  }, item.value);
                }), [items])]
              })
            }), /* @__PURE__ */jsx(Select.ScrollDownButton, {})]
          })]
        })
      })]
    })
  });
};
export { DropDownPickerView };
//# sourceMappingURL=DropDownPicker.mjs.map
